import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core'
import { MatCalendar } from '@angular/material/datepicker'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
} from '@angular/material/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { tap } from 'rxjs'
import { MatIconModule } from '@angular/material/icon'

@UntilDestroy()
@Component({
  selector: 'wm-front-date-range-picker-header',
  imports: [MatIconModule],
  templateUrl: './date-range-picker-header.component.html',
  styleUrls: ['./date-range-picker-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerHeaderComponent<D> implements OnInit {
  private _calendar = inject<MatCalendar<D>>(MatCalendar)

  private _dateAdapter = inject<DateAdapter<D>>(DateAdapter)

  private _dateFormats = inject<MatDateFormats>(MAT_DATE_FORMATS)

  private _cdr = inject(ChangeDetectorRef)

  public get periodLabel() {
    return this._dateAdapter.format(
      this._calendar.activeDate,
      this._dateFormats.display.monthYearLabel
    )
  }

  public ngOnInit() {
    this.manageCalendarStateChanged()
  }

  /**
   * Will add or remove a month when the button is clicked
   * @param {1 | -1} valueToAdd
   */
  public addMonth(valueToAdd: 1 | -1) {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      valueToAdd
    )
  }

  /**
   * This method will know what to do when the calendar state changed
   * @private
   */
  private manageCalendarStateChanged(): void {
    this._calendar.stateChanges
      .pipe(
        tap(() => this._cdr.markForCheck()),
        untilDestroyed(this)
      )
      .subscribe()
  }
}
